import { createAsyncActionTypes } from '@mews/framework/redux';

const AUTHORIZE_PAYMENT_CARD = 'AUTHORIZE_PAYMENT_CARD';
export const [AUTHORIZE_PAYMENT_CARD_STARTED, AUTHORIZE_PAYMENT_CARD_SUCCEEDED, AUTHORIZE_PAYMENT_CARD_FAILED] =
    createAsyncActionTypes(AUTHORIZE_PAYMENT_CARD);
